export default {
  title: 'Dettagli ordine',
  order_again: 'Ordina di nuovo',
};
